import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src2515980017/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Terms and conditions applicable to .name registrations</h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  <strong>1. REPRESENTATIONS AND WARRANTIES OF REGISTRANT.</strong> You hereby
  represent, warrant and agree:
    </p>
    <blockquote>
  <p>
    (a) that the registered domain name or second level domain (“SLD”) email
    address is your Personal Name; (b) that the registration satisfies the
    Eligibility Requirements; (c) to be subject to the Eligibility Requirements
    Dispute Resolution Policy (the "ERDRP") and the Uniform Domain Name Dispute
    Resolution Policy (the "UDRP"); and (d) that Registry Operator will have no
    liability of any kind for any loss or liability resulting from (i) the
    processing of registration requests prior to live SRS launch, including,
    without limitation, the ability or inability of Registrant to obtain a
    Registered Name or SLD E-mail Address registration using these processes; or
    (ii) any dispute over any Registered Name, SLD E-mail Address, Defensive
    Registration or NameWatch Registration, including the decision of any
    dispute resolution proceeding related to any of the foregoing.
  </p>
    </blockquote>
    <p>
  <strong>2. ADDITIONAL PROVISIONS RELATING TO DOMAIN NAME DISPUTES.</strong> In
  addition to section 14, you hereby acknowledge that you have read and
  understood and agree to be bound by the terms and conditions of the following
  documents, as they may be amended from time to time, which are hereby
  incorporated and made an integral part of this Agreement:
    </p>
    <blockquote>
  <p>
    (a) the Eligibility Requirements (the “Eligibility Requirements”), available
    at{' '}
    <a href="http://www.icann.org/tlds/agreements/name/registry-agmt-appl-03jul01.htm" target="_blank">
      http://www.icann.org/tlds/agreements/name/registry-agmt-appl-03jul01.htm
    </a>
    ;
  </p>
  <p>
    (b) the Eligibility Requirements Dispute Resolution Policy (the "ERDRP"),
    available at{' '}
    <a href="http://www.icann.org/tlds/agreements/name/registry-agmt-appm-03jul01.htm" target="_blank">
      http://www.icann.org/tlds/agreements/name/registry-agmt-appm-03jul01.htm
    </a>
    ; and
  </p>
  <p>
    (c) the Uniform Domain Name Dispute Resolution Policy (the "UDRP"),
    available at{' '}
    <a href="http://www.icann.org/tlds/agreements/name/registry-agmt-appm-03jul01.htm" target="_blank">
      {' '}
      http://www.icann.org/tlds/agreements/name/registry-agmt-appm-03jul01.htm{' '}
    </a>
    .
  </p>
    </blockquote>
    <p>
  The Eligibility Requirements dictate that Personal Name domain names and
  Personal Name SLD email addresses will be granted on a first-come,
  first-served basis, except for registrations granted as a result of a dispute
  resolution proceeding or during the landrush procedures in connection with the
  opening of the Registry TLD. The following categories of Personal Name
  Registrations may be registered: (i) the Personal Name of an individual; (ii)
  the Personal Name of a fictional character, if you have trademark or service
  mark rights in that character's Personal Name; (iii) in addition to a Personal
  Name registration, you may add numeric characters to the beginning or the end
  of your Personal Name so as to differentiate it from other Personal Names. The
  ERDRP applies to challenges to (i) registered domain names and SLD email
  address registrations within .name on the grounds that a Registrant does not
  meet the Eligibility Requirements, and (ii) to Defensive Registrations within
  .name.
    </p>
    <p>
  The UDRP sets forth the terms and conditions in connection with a dispute
  between a Registrant and party other than Global Name Registry (“Registry
  Operator”) or Registrar over the registration and use of an Internet domain
  name registered by a Registrant.
    </p>
    <p>
  <strong>3. EMAIL FORWARDING.</strong>
    </p>
    <blockquote>
  <p>
    (a) The service for which you have registered may, at your option, include
    Email Forwarding. To the extent you opt to use Email Forwarding, you are
    obliged to do so in accordance with all applicable legislation and are
    responsible for all use of Email Forwarding, including the content of
    messages sent through Email Forwarding.
  </p>
  <p>
    (b) You undertake to familiarize yourself with the content of and to comply
    with the generally accepted rules for Internet and email usage. This
    includes, but is not limited to the Acceptable Use Policy, as well as the
    following restrictions. Without prejudice to the foregoing, you undertake
    not to use Email Forwarding:
  </p>
  <blockquote>
    <p>
      (i) to encourage, allow or participate in any form of illegal or
      unsuitable activity, including but not restricted to the exchange of
      threatening, obscene or offensive messages, spreading computer viruses,
      breach of copyright and/or proprietary rights or publishing defamatory
      material;
    </p>
    <p>
      (ii) to gain illegal access to systems or networks by unauthorized access
      to or use of the data in systems or networks, including all attempts at
      guessing passwords, checking or testing the vulnerability of a system or
      network or breaching the security or access control without the sufficient
      approval of the owner of the system or network;
    </p>
    <p>
      (iii) to interrupt data traffic to other users, servers or networks,
      including, but not restricted to, mail bombing, flooding, Denial of
      Service (DoS) attacks, willful attempts to overload another system or
      other forms of harassment; or
    </p>
    <p>
      (iv) for spamming, which includes, but is not restricted to, the mass
      mailing of unsolicited email, junk mail, the use of distribution lists
      (mailing lists) which include persons who have not specifically given
      their consent to be placed on such a distribution list.
    </p>
    <p>
      Users are not permitted to provide false names or in any other way to pose
      as somebody else when using Email Forwarding.
    </p>
  </blockquote>
  <p>
    (c) Registry Operator reserves the right to implement additional anti-spam
    measures, to block spam or mail from systems with a history of abuse from
    entering Registry Operator’s Email Forwarding. However, due to the nature of
    such systems, which actively block messages, Registry Operator shall make
    public any decision to implement such systems a reasonable time in advance,
    so as to allow you or [Registrar] to give feedback on the decision.
  </p>
  <p>
    (d) You understand and agree that Registry Operator may delete material that
    does not conform to clause (c) above or that in some other way constitutes a
    misuse of Email Forwarding. You further understand and agree that Registry
    Operator is at liberty to block your access to Email Forwarding if you use
    Email Forwarding in a way that contravenes this Agreement. You will be given
    prior warning of discontinuation of the Email Forwarding unless it would
    damage the reputation of Registry Operator or jeopardize the security of
    Registry Operator or others to do so. Registry Operator reserves the right
    to immediately discontinue Email Forwarding without notice if the technical
    stability of Email Forwarding is threatened in any way, or if you are in
    breach of this Agreement. On discontinuing Email Forwarding, Registry
    Operator is not obliged to store any contents or to forward unsent email to
    you or a third party.
  </p>
  <p>
    (e) You understand and agree that to the extent Registry Operator is
    required by law to disclose certain information or material in connection
    with your Email Forwarding, Registry Operator will do so in accordance with
    such requirement and without notice to you.
  </p>
    </blockquote>
    <p>
  <strong>4. LIMITATION OF LIABILITY.</strong> You agree that Registry Operator
  will have no liability of any kind for any loss or liability resulting from
  (i) the processing of registration requests prior to live SRS launch,
  including, without limitation, your ability or inability to obtain a .name
  domain name or SLD email address registration using these processes; or (ii)
  any dispute over any .name domain name, SLD email address, Defensive
  Registration or NameWatch Registration, including the decision of any dispute
  resolution proceeding related to any of the foregoing.
    </p>
    <p>
  <strong>5. INDEMNIFICATION. </strong> You agree to indemnify, defend and hold
  harmless Registry Operator, and its directors, officers, employees and agents
  from and against any and all claims, damages, liabilities, costs and expenses,
  including reasonable legal fees and expenses, arising out of or relating to
  your registration. This indemnification obligation will survive the
  termination or expiration of this Agreement.
    </p>
    <p>
  <a href="#top">Back to Top</a>
    </p>
    <h4>
  <a name="schedulec"></a>Schedule C: Terms and conditions applicable to .name defensive
  registrations:
    </h4>
    <p>
  <strong>1. PHASES OF DEFENSIVE REGISTRATIONS.</strong>
    </p>
    <blockquote>
  <p>
    (a) As a Defensive Registration Registrant (“Defensive Registrant”), you
    hereby certify to the best of your knowledge that for Phase I Defensive
    Registrations (“Phase I Defensive Registrants”), you own valid and
    enforceable trademark or service mark registrations having national effect
    that issued prior to April 16, 2001 for strings that are identical to the
    textual or word elements, using ASCII characters only, subject to the same
    character and formatting restrictions as apply to all registrations in the
    Registry TLD. You understand that trademark or service mark registrations
    from the supplemental or equivalent Registry of any country, or from
    individual states or provinces of a nation, will not be accepted. Subject to
    the same character and formatting restrictions as apply to all registrations
    in the Registry TLD, if a trademark or service mark registration
    incorporates design elements, the ASCII character portion of that mark may
    qualify to be a Phase I Defensive Registration.
  </p>
  <p>
    (b) Phase II Defensive Registrants may apply for a Defensive Registration
    for any string or combination of strings.
  </p>
  <p>
    (c) Defensive Registrants, whether Phase I or Phase II shall comply with the
    following Eligibility Requirements, available at{' '}
    <a href="http://www.icann.org/tlds/agreements/name/registry-agmt-appl-03jul01.htm" target="_blank">
      http://www.icann.org/tlds/agreements/name/registry-agmt-appl-03jul01.htm
    </a>{' '}
    , the summary of which is as follows:
  </p>
  <blockquote>
    <p>
      (i) There are two levels of Defensive Registrations, each of which is
      subject to payment of a separate fee;
    </p>
    <p>
      (ii) Multiple persons or entities may obtain identical or overlapping
      Defensive Registrations upon payment by each of a separate registration
      fee;
    </p>
    <p>
      (iii) The Defensive Registrant must provide the information requested in
      Section 3(a) below;
    </p>
    <p>
      (iv) A Defensive Registration will not be granted if it conflicts with a
      then-existing Personal Name Registration or other reserved word or string.
    </p>
  </blockquote>
    </blockquote>
    <p>
  <strong>2. REPRESENTATIONS AND WARRANTIES OF DEFENSIVE REGISTRANT.</strong>{' '}
  You hereby represent, warrant and agree:
    </p>
    <blockquote>
  <p>(a) that the registration satisfies the Eligibility Requirements;</p>
  <p>
    (b) that the Defensive Registration will be subject to challenge pursuant to
    the ERDRP;
  </p>
  <p>
    (c) that if the Defensive Registration is successfully challenged pursuant
    to the ERDRP, the Defensive Registrant will pay the challenge fees; and
  </p>
  <p>
    (d) that if a challenge is successful, then the Defensive Registration will
    be subject to the procedures described in the ERDRP and the Eligibility
    Requirements including, without limitation, the cancellation of the
    Defensive Registrant’s other Defensive Registrations;
  </p>
  <p>
    (e) that if a Phase I Defensive Registration (as described in Appendices C
    and L to the Registry Agreement) is successfully challenged on the basis
    that it did not meet the applicable eligibility requirements, the Defensive
    Registrant will thereafter be required to demonstrate, at its expense, that
    it meets the eligibility requirements for Phase I Defensive Registrations
    for all other Phase I Defensive Registrations that it registered within
    .name through any Registrar. In the event that the Defensive Registrant is
    unable to demonstrate the foregoing with respect to any such Phase I
    Defensive Registration(s), those Defensive Registration(s) will be
    cancelled; and
  </p>
  <p>
    (f) that Registry Operator will have no liability of any kind for any loss
    or liability resulting from (i) the processing of registration requests
    prior to live SRS launch, including, without limitation, the ability or
    inability of Defensive Registrant to obtain a Defensive Registration or
    NameWatch Registration using these processes; or (ii) any dispute over any
    Registered Name, SLD E-mail Address, Defensive Registration or NameWatch
    Registration, including the decision of any dispute resolution proceeding
    related to any of the foregoing.
  </p>
    </blockquote>
    <p>
  <strong>3. DOMAIN DISPUTE POLICY.</strong>
    </p>
    <blockquote>
  <p>
    (a) If you registered a Defensive Registration, you agree that: (i) the
    Defensive Registration will be subject to challenge pursuant to the
    Eligibility Requirements Dispute Resolution Policy (“ERDRP”); (ii) if the
    Defensive Registration is successfully challenged pursuant to the ERDRP, the
    Defensive Registrant will pay the challenge fees; and (iii) if a challenge
    is successful, then the Defensive Registration will be subject to the
    procedures described in Section 2(h) of Appendix L to the agreement of
    Global Name Registry (“Registry Operator”) with the Internet Corporation for
    Assigned Names and Numbers (“ICANN”), available at{' '}
    <a href="http://www.icann.org/tlds/agreements/name/registry-agmt-appl-03jul01.htm" target="_blank">
      http://www.icann.org/tlds/agreements/name/registry-agmt-appl-03jul01.htm
    </a>
  </p>
  <p>
    (b) You further agree that if a Phase I Defensive Registration is
    successfully challenged on the basis that it did not meet the applicable
    Eligibility Requirements, the Defensive Registrant will thereafter be
    required to demonstrate, at its expense, that it meets the Eligibility
    Requirements for Phase I Defensive Registrations for all other Phase I
    Defensive Registrations that it registered within .name through any
    Registrar. In the event that the Defensive Registrant is unable to
    demonstrate the foregoing with respect to any such Phase I Defensive
    Registration(s), those Defensive Registration(s) will be cancelled.
  </p>
  <p>
    (c) The ERDRP applies to, among other things, challenges to Defensive
    Registrations within .name and is available at{' '}
    <a href="http://www.icann.org/tlds/agreements/name/registry-agmt-appm-03jul01.htm" target="_blank">
      http://www.icann.org/tlds/agreements/name/registry-agmt-appm-03jul01.htm
    </a>
  </p>
    </blockquote>
    <p>
  <strong>4. CONSENT.</strong> Defensive Registrants may be asked to give their
  consent to allow individuals to share a part of their space. For example, if
  you have filed a Defensive Registration on PQR (which blocks out
  ANYSTRING.PQR.name and PQR.ANYSTRING.name) you may be asked to give consent to
  John Pqr to register JOHN.PQR.name if he can prove that PQR is his name. In
  such a circumstance, you will have five (5) days to respond to a request for
  consent.
    </p>
    <p>
  <strong>5. LIMITATION OF LIABILITY.</strong> You agree that Registry Operator
  will have no liability of any kind for any loss or liability resulting from
  (i) the processing of Defensive Registration requests prior to live SRS
  launch, including, without limitation, your ability or inability to obtain a
  Registered Name or SLD email address registration using these processes; or
  (ii) any dispute over any .name domain name, SLD email address, Defensive
  Registration or NameWatch Registration, including the decision of any dispute
  resolution proceeding related to any of the foregoing.
    </p>
    <p>
  <strong>6. INDEMNIFICATION.</strong> You agree to indemnify, defend and hold
  harmless Registry Operator, and its directors, officers, employees and agents
  from and against any and all claims, damages, liabilities, costs and expenses,
  including reasonable legal fees and expenses, arising out of or relating to
  your registration. This indemnification obligation will survive the
  termination or expiration of this Agreement.
    </p>
    <a href="/terms-conditions">Back to Terms and Conditions</a>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      